import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

export default function AdminTowns() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const load = useCallback(async () => setItems((await api.get("/admin/towns")).data), []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!name.trim()) return;
    await api.post("/admin/towns", { name: name.trim(), active: true, order: items.length });
    setName(""); toast.success("Added"); load();
  };
  const upd = async (t, patch) => {
    await api.patch(`/admin/towns/${t.id}`, { name: t.name, active: t.active, order: t.order, ...patch });
    load();
  };
  const del = async (id) => { if (!confirm("Delete town?")) return; await api.delete(`/admin/towns/${id}`); load(); };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-[#1A3C5A] mb-4">Towns</h1>
      <div className="flex gap-2 mb-4 max-w-md">
        <Input value={name} onChange={(e)=>setName(e.target.value)} placeholder="New town name…" className="bg-white" data-testid="new-town-name"/>
        <Button onClick={add} className="bg-[#1A3C5A] text-white hover:bg-[#12293e]" data-testid="add-town-btn"><Plus size={14} className="mr-1"/>Add</Button>
      </div>
      <div className="bg-white border border-border rounded-md overflow-hidden max-w-2xl">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500 font-display">
            <tr><th className="py-2 px-2 text-left">Name</th><th className="py-2 px-2">Active</th><th className="py-2 px-2 w-16"></th></tr>
          </thead>
          <tbody>
            {items.map(t => (
              <tr key={t.id} className="border-t border-border" data-testid={`town-row-${t.id}`}>
                <td className="py-1.5 px-2">
                  <Input defaultValue={t.name} onBlur={(e)=> e.target.value !== t.name && upd(t, { name: e.target.value })}
                         className="h-8 border-transparent hover:border-border focus:border-[#1A3C5A]"/>
                </td>
                <td className="py-1.5 px-2 text-center">
                  <Switch checked={t.active} onCheckedChange={(v)=>upd(t, { active: v })} />
                </td>
                <td className="py-1.5 px-2 text-right">
                  <Button size="sm" variant="ghost" onClick={()=>del(t.id)} className="text-red-600"><Trash2 size={13}/></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
